import React, { useEffect, useState } from 'react'
import request from 'meinian-package/src/utils/request'
import Select from 'meinian-package/src/baseComponent/select'

const convert = (result) => {
  return result.map(m => ({ label: m.userName, value: m.userId }))
}

export default ({ value, inspirationId, placeholder = '团队成员', onChange, ...rest }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    fetchUsers()
  }, [inspirationId])

  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector', { params: { inspirationId } })
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select
    allowClear
    placeholder={placeholder}
    value={value}
    data={options}
    onChange={onChange}
    {...rest}
  />
}
